import { Injectable } from '@angular/core'
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router'
import { TrackingService } from '../tracking.service'

/**
 * @deprecated
 *
 * TypeaccessloginGuard
 *
 * @author Jesús Fernández
 *
 * Using like a middleware method to send type access login event sms or email IMPORTANT -> NOT USED GUARD DEPRECATED IN PROJECT
 */
@Injectable({
  providedIn: 'root'
})
export class TypeaccessloginGuard implements CanActivate {
  /**
   * @ignore
   */
  constructor(private trackingService: TrackingService) {}

  /**
   * Using like a middleware method to send type access login event sms or email
   * checks if previous path route contains pyf, example -> domain.com/pyf/983948
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true
  }
}
